export default function getEnvironmentConfig() {
  const env = window.__ENV__ || {}; // eslint-disable-line no-underscore-dangle
  return {
    // TODO: Should these default to dev values or localhost 8080/8081 for app/dashboard respectively?
    appUrl: env.APP_URL || 'https://app.dev.edukate.ai',
    dashboardUrl: env.DASHBOARD_URL || 'https://dashboard.dev.edukate.ai',
    environment: env.ENVIRONMENT || 'local',
    formbricksEnvironmentId: env.FORMBRICKS_ENVIRONMENT_ID,
    certificateDomain: env.CERTIFICATE_DOMAIN || 'achievement-889423904125.europe-west1.run.app', // Default to dev certificate domain
  };
}
